import React, { useState } from "react";

const Form = ({ handleSubmit, formData, onDiscard }) => {
  // State to manage the form data
  const [form, setForm] = useState(formData);

  // State to manage error for layer class name input
  const [errorLayerChoiceName, setErrorLayerChoiceName] = useState(false);

  // Function to handle changes in form inputs
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value, // Update the form state with the new input value
    });
  };

  // Function to handle the submission of the form
  const handleClick = () => {
    setErrorLayerChoiceName(false); // Reset error state

    // Validate if layer class name is provided
    if (!form.layer_class_name) {
      setErrorLayerChoiceName(true); // Set error if the name is missing
    } else {
      // If the validation passes, submit the form data to the parent component
      handleSubmit(form);
    }
  };

  return (
    <>
      {/* Input field for layer class name */}
      <div className="mt-4">
        <label htmlFor="layer_choice_name" className="form-labels">Layer Class Name:</label>

        <input
          type="text"
          name="layer_class_name" // Name of the input field
          id="layer_class_name" // Corresponding ID
          placeholder="Default input" // Placeholder text
          onChange={handleChange} // Handle input change
          value={form.layer_class_name} // Bind input value to form state
          className="form-control mt-2 inputs" // CSS classes for styling
        />

        {/* Error message for empty layer class name */}
        {errorLayerChoiceName ? (
          <span id="errorLayerChoiceName" className="form-text text-danger">
            Name is required!
          </span>
        ) : (
          <span></span>
        )}
      </div>

      <div className="pt-5">
        {/* Button to discard changes and reset the form */}
        <div className="btn btn-secondary form-btn me-4" onClick={onDiscard}>
          Discard
        </div>

        {/* Submit button to save changes */}
        <input
          type="submit"
          value="Save Changes" // Button text
          className="btn bg-orange form-btn" // CSS classes for styling
          onClick={handleClick} // Handle form submission
        />
      </div>
    </>
  );
};

export default Form;
